import * as React from "react";

import { useNavigate } from "react-router-dom";

import Textfield from "../../Components/Textfield";
import Textarea from "../../Components/Textarea";
import Button from "../../Components/Button";
import Paper from "../../Components/Paper";
import Motive from "./Motive";

import axiosInstance from "../../Api/Axios";
import { useToast } from "../../Context/ToastContext";
import { useLoader } from "../../Context/LoaderContext";

import "./AddContact.scss";

const initialFormState = {
  type: "",
  date: "",
  time: "",
  message: "",
};

const AddContact = () => {
  const [valRegister, setValRegister] = React.useState(initialFormState);
  const [formErrorMessages, setFormErrorMessages] = React.useState("");

  const navigate = useNavigate();

  const { addToast } = useToast();
  const { setIsLoading } = useLoader();

  const handleChangeField = (e, key) => {
    let value = e.target.value;

    if (key === "date") {
      const day = new Date(value).getDay(); // Returns 0 (Sunday) to 6 (Saturday)
      if (day === 0 || day === 6) {
        setFormErrorMessages((prev) => ({
          ...prev,
          [key]: "Les samedis et dimanches ne sont pas autorisés.",
        }));
        return; // Exit the function without updating the state
      }
    }

    setFormErrorMessages((prev) => ({
      ...prev,
      [key]: "",
    }));

    setValRegister((prev) => ({
      ...prev,
      [key]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setIsLoading(true);
    axiosInstance
      .post(`${process.env.REACT_APP_API_URL}/leasing-contact-advisor`, {
        type: valRegister.type,
        date: valRegister.date,
        // date: moment(valRegister.date, "YYYY-MM-DD").format("dd/mm/yyyy"),
        time: valRegister.time,
        message: valRegister.message,
      })
      .then((response) => {
        setIsLoading(false);

        if (response.data.status) {
          addToast({
            variant: "success",
            message: response.data.message,
          });
          navigate("/");
        }
      })
      .catch((error) => {
        setIsLoading(false);

        if (error.response.data.errors) {
          setFormErrorMessages(error.response.data.errors);
        } else {
          addToast({
            variant: "danger",
            message: error.response.data.message,
          });
        }
      });
  };

  return (
    <>
      <h1>Prise de RDV</h1>
      <p>Veuillez compléter votre demande de prise de Rendez-vous</p>
      <Paper>
        <form className="register-form" onSubmit={handleSubmit} noValidate>
          <Motive
            label="Motif de prise de RDV"
            name="type"
            id="type"
            value={valRegister.type || ""}
            onChange={(e) => handleChangeField(e, "type")}
            required
            hasError={formErrorMessages.type}
            errorMessage={
              <div className="text-danger">{formErrorMessages.type}</div>
            }
          ></Motive>
          <div className="wrap-immatriculation">
            <Textfield
              autoComplete="off"
              label="Date"
              name="date"
              type="date"
              size="large"
              min={new Date().toISOString().split("T")[0]}
              value={valRegister.date}
              onChange={(e) => handleChangeField(e, "date")}
              hasError={formErrorMessages.date}
              errorMessage={
                formErrorMessages.date && (
                  <div className="text-danger">{formErrorMessages.date}</div>
                )
              }
            />
            <Textfield
              autoComplete="off"
              label="Heure"
              name="time"
              type="time"
              size="large"
              value={valRegister.time}
              onChange={(e) => handleChangeField(e, "time")}
              hasError={formErrorMessages.time}
              errorMessage={
                formErrorMessages.time && (
                  <div className="text-danger">{formErrorMessages.time}</div>
                )
              }
            />
          </div>
          <Textarea
            autoComplete="off"
            label="Message"
            name="message"
            type="text"
            placeholder="Message"
            size="large"
            value={valRegister.message}
            onChange={(e) => handleChangeField(e, "message")}
            hasError={formErrorMessages.message}
            errorMessage={
              formErrorMessages.message && (
                <div className="text-danger">{formErrorMessages.message}</div>
              )
            }
          />
          <div className="wrap_actions_form">
            <Button type="submit" size="lg">
              Envoyer
            </Button>
          </div>
        </form>
      </Paper>
    </>
  );
};

export default AddContact;
